import { solutionConstants } from './solutionsConstants';

const miCitaRules = {
  birthdate: true,
  birthdateRequired: true,
  biologicalSex: true,
  addressRequired: true,
  showMobilePhone: true,
  emailRequired: false,
  landlinePhoneRequired: false,
  showBloodType: true,
  showhealthInsurance: true,
  showRegime: true,
  addressExtra: true,
  showName1: true,
  showName2: true,
  showlastname1: true,
  showlastname2: true,
  name: false,
  showScholarlyLevel: true,
};

const tapptusRules = {
  showName2: false,
  showlastname1: false,
  showlastname2: false,
  birthdate: false,
  birthdateRequired: false,
  biologicalSex: false,
  addressRequired: true,
  showMobilePhone: false,
  emailRequired: true,
  landlinePhoneRequired: true,
  showBloodType: false,
  showhealthInsurance: false,
  showRegime: false,
  addressExtra: true,
  showName1: false,
  name: true,
  showScholarlyLevel: false,
};

const finalCustomerSolutionIdRules = {
  [solutionConstants.TAPPTUS.id]: tapptusRules,
  [solutionConstants.MIEMERGENCIA.id]: miCitaRules,
  default: miCitaRules,
};

export { miCitaRules, tapptusRules, finalCustomerSolutionIdRules };
